import React from "react";

export default function Graphana() {
  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <div className="container">
          {/* <div className="row mb-5">
            <div className="col-md-6">
              <iframe
                className="height_width"
                src="https://acmp-report.altruistindia.com/d-solo/Is3eVIvVz/revenue?orgId=1&from=1653133465726&to=1669031065726&theme=light&panelId=4?embed=true"
                // width="100%"
                // height="900px"
                frameborder="0"
              ></iframe>
            </div>
            <div className="col-md-6">
              <iframe
                className="height_width"
                src="https://acmp-report.altruistindia.com/d-solo/Is3eVIvVz/revenue?orgId=1&from=1653133706886&to=1669031306886&theme=light&panelId=6?embed=true"
                // width="100%"
                // height="900px"
                frameborder="0"
              ></iframe>
            </div>
          </div> */}
          {/* <div className="row">
            <div className="col-md-12">
              <iframe
                className="height_width margin__38"
                src="https://acmp-report.altruistindia.com/d-solo/Is3eVIvVz/revenue?orgId=1&from=1653133758518&to=1669031358518&theme=light&panelId=2?embed=true"
                // width="100%"
                // height="900px"
                frameborder="0"
              ></iframe>
            </div>
          </div> */}
          <div className="row">
            <div className="col-md-12">
              <iframe
                // className="height_width margin__38"
                src="https://acmp-report.altruistindia.com/d/rYdddlPWk/monitoring-network?orgId=1&refresh=1embed=true"
                width="100%"
                height="900px"
                frameborder="0"
              ></iframe>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
